/**
 * Replace all occurrences of a string with another string
 * @param string string
 * @param search string
 * @param replace string
 * @returns string
 */
export const replaceAll = (string, search, replace) => {
  return string.split(search).join(replace);
};
